import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import useDocumentMetadata from '../hooks/useDocumentMetadata';

const NotFound = () => {
  useDocumentMetadata(
    'Page Not Found (404) — Dakhla',
    'The page you are looking for does not exist or has been moved. Explore Pakistani universities and programs on Dakhla.'
  );

 return (
 <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
 <div className="max-w-md w-full text-center">
 {/* 404 Illustration */}
 <div className="mb-8">
 <h1 className="text-9xl font-bold text-primary-600">404</h1>
 <div className="mt-4">
 <svg
 className="mx-auto h-32 w-32 text-slate-400"
 fill="none"
 viewBox="0 0 24 24"
 stroke="currentColor"
 aria-hidden="true"
 >
 <path
 strokeLinecap="round"
 strokeLinejoin="round"
 strokeWidth={2}
 d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
 />
 </svg>
 </div>
 </div>

 {/* Error Message */}
 <h2 className="text-3xl font-bold text-slate-900 mb-4">
 Page Not Found
 </h2>
 <p className="text-lg text-slate-600 mb-8">
 Sorry, we couldn't find the page you're looking for. The page might have been moved or doesn't exist.
 </p>

 {/* Action Button */}
 <div className="flex justify-center">
 <Link
 to="/"
 className="btn-primary inline-flex items-center gap-2"
 >
 <HomeIcon className="h-5 w-5" />
 Go to Homepage
 </Link>
 </div>

 {/* Help Text */}
 <p className="mt-8 text-sm text-slate-500">
 Need help? <Link to="/contact" className="text-primary-600 hover:text-primary-700 font-medium">Contact us</Link>
 </p>
 </div>
 </div>
 );
};

export default NotFound;
